import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export async function fetchUploadHistory2() {
  try {

    
    const response = await fetch(`${BASE_URL}insurance/upload-history/`, {
      method: "GET",
      headers: {
        "Accept": "application/json", // Especificamos que queremos JSON
        ...getAuthHeader(),
      },
    });
    
    // Verificar el content-type antes de parsear
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      throw new Error(`Respuesta no JSON: ${text.substring(0, 100)}...`);
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Error al obtener historial");
    }

    return await response.json();
  } catch (error) {
    console.error("Error completo en fetchUploadHistory:", error);
    throw error;
  }
}

export async function saveBulkUploadHistory(historyData) {
  try {
  
    const validatedData = {
      ...historyData,
      status: historyData.status === 'partial' ? 'completed' : historyData.status 
    };

    const response = await fetch(`${BASE_URL}insurance/upload-history/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(validatedData), // Envía los datos validados
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || errorData.message || "Error al guardar el historial");
    }

    return await response.json();
  } catch (error) {
    console.error("Error al guardar el historial:", error);
    throw error; 
  }
}